module.exports = __webpack_public_path__ + "img/UTSAND-8.874b8580.jpg";